import { render, staticRenderFns } from "./PotensiDetailView.vue?vue&type=template&id=501ca57c&scoped=true"
import script from "./PotensiDetailView.vue?vue&type=script&lang=js"
export * from "./PotensiDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501ca57c",
  null
  
)

export default component.exports